// "map.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
// 지도(DroneMapTest)·드론 마커·NDVI 토글/날짜 모달·진단 알림 판정(diagnosisUpdates)이 쓴다.
// aria-label 가운데 "Open date picker"/"Date caret" 는 테스트가 이름으로 버튼을 찾으므로
// ko 에서도 영어 그대로 둔다.
const map = {
  ko: {
    // 칸 등급(지도 칸 HIGH/MID/OK, 크롭 한 장 high/mid/ok 모두 같은 말을 쓴다)
    "grade.high": "심각",
    "grade.mid": "주의",
    "grade.ok": "정상",
    "gradeNote.high": "심각 · 바로 확인이 필요합니다",
    "gradeNote.mid": "주의 · 지켜볼 단계입니다",
    "gradeNote.ok": "이상 없음",
    "filter.all": "전체",

    // 에너지 장치(스마트폴 · 태양광큐브) 마커 툴팁. 실계정 · 데모 공통(utils/energyDevices).
    // 첫 줄은 이름(fog 구성이면 " · fog/edge"), 둘째 줄은 상태 · 배터리.
    "device.operating": "정상 작동",
    "device.abnormal": "이상 감지",
    "device.disconnected": "연결 끊김",
    "device.unknown": "상태 확인 전",
    "device.battery": "배터리 {battery}%",
    "device.role.FOG": "fog",
    "device.role.EDGE": "edge",

    // 드론 마커(DroneTracker)
    "marker.droneTitle": "드론 ID: {id}\n고도: {alt}m\n배터리: {battery}\n상태: {status}",

    // 토스트
    "toast.noImages": "아직 이미지가 없습니다. 사진이 업로드 중일 수 있습니다.",
    "toast.noAnalysis": "이 농장에는 분석 데이터가 없습니다.",
    "toast.noCellResult": "이 구역은 아직 분석 결과가 없습니다.",
    "toast.updateFetchFailed": "새 분석 결과 조회에 실패했습니다. 잠시 후 다시 확인해 주세요.",

    // 새 진단 결과 알림(utils/diagnosisUpdates)
    "diagnosis.newResultUnresolved": "새 분석 결과가 도착했습니다. 촬영 회차 목록에서 확인해 주세요.",
    "diagnosis.newResultOtherDate": "다른 날짜의 촬영 회차에 새 분석 결과가 도착했습니다.",
    "diagnosis.newResultOtherRun": "다른 촬영 회차에 새 분석 결과가 도착했습니다.",
    "diagnosis.newResultBatch": "새 분석 결과가 도착했습니다 (회차 {count}개). 촬영 회차 목록에서 확인해 주세요.",

    // 지도 위 공용
    "loading.map": "지도를 불러오는 중…",
    "fit.aria": "농장 전체 보기",
    "fit.label": "전체",
    "orderTip.text": "{at} / {total}번째",
    "empty.noFlightData": "비행 데이터가 없습니다",

    // 칸 요약 툴팁
    "cell.title": "{cellId}번 칸",
    "gradeTip.close": "요약 닫기",
    "gradeTip.detected": "검출 {count}장 · {grade}",

    // 날짜·회차 선택
    // 아래 두 aria-label 은 DroneMapTest.test.js 가 이름으로 찾으므로 한글 모드에서도 영어로 둔다.
    "date.openPicker": "Open date picker",
    "date.caret": "Date caret",
    "date.noLogs": "비행 기록이 없습니다",

    // 범례
    "legend.title": "진단 등급",
    "legend.highRange": "{high}% 이상",
    "legend.midRange": "{mid} ~ {max}% 이상",
    "legend.okNote": "찍었고 이상 없음",
    "legend.none": "미촬영",
    "legend.noneNote": "이번 회차에 안 감 ",

    // 지도 도구
    "tools.diagnosis": "진단",
    "tools.diagnosisOn": "촬영 회차 진단 결과 보기",
    "tools.diagnosisOff": "진단 결과 닫기",
    "tools.zoomIn": "확대",
    "tools.zoomOut": "축소",

    // 칸 원본 이미지 오버레이
    "cellImage.close": "이미지 닫기",
    "cellImage.alt": "작물 상세 이미지",
    "cellImage.empty": "이미지가 없습니다",
    "cellImage.openPreview": "이미지 크게 보기",
    "cellImage.thumbAlt": "작물 썸네일",

    // 칸 진단 컨택트시트
    "preview.title": "칸 진단",
    "preview.close": "닫기",
    "preview.empty": "아직 분석된 사진이 없습니다.",
    "preview.detected": "검출 {count}장",
    "preview.objectsAndDiagnoses": "개체 {count}개 · 진단 {diagnoses}건",
    "preview.gradcamFor": "Grad-CAM 대상: {name}",
    "preview.gradcam": "Grad-CAM",
    "preview.tileAria": "{n}번째 장 크게 보기",
    "preview.hint": "한 장을 누르면 크게 봅니다",
    "preview.backToList": "목록",
    "preview.prev": "이전 장",
    "preview.next": "다음 장",
    "preview.zoomPos": "{scope}{at} / {total}장",

    // NDVIToggle / NDVIDateModal
    "ndvi.toggleAlt": "NDVI 전환",
    "dateModal.title": "날짜 선택",
    "dateModal.cancel": "취소",
    "dateModal.apply": "적용",
  },
  en: {
    "preview.objectsAndDiagnoses": "{count} objects · {diagnoses} diagnoses",
    "preview.gradcamFor": "Grad-CAM for: {name}",
    "grade.high": "Severe",
    "grade.mid": "Caution",
    "grade.ok": "Normal",
    "gradeNote.high": "Severe · Needs immediate attention",
    "gradeNote.mid": "Caution · Keep an eye on it",
    "gradeNote.ok": "No issues",
    "filter.all": "All",

    "device.operating": "Operating normally",
    "device.abnormal": "Abnormal",
    "device.disconnected": "Disconnected",
    "device.unknown": "Status pending",
    "device.battery": "Battery {battery}%",
    "device.role.FOG": "fog",
    "device.role.EDGE": "edge",

    "marker.droneTitle": "Drone ID: {id}\nAltitude: {alt}m\nBattery: {battery}\nStatus: {status}",

    "toast.noImages": "No images available yet. Photos may still be uploading.",
    "toast.noAnalysis": "No analysis data available for this farm.",
    "toast.noCellResult": "No analysis results for this zone yet.",
    "toast.updateFetchFailed": "Failed to load the new analysis result. Please check again shortly.",

    "diagnosis.newResultUnresolved": "A new analysis result has arrived. Check the capture run list.",
    "diagnosis.newResultOtherDate": "A new analysis result arrived for a run on another date.",
    "diagnosis.newResultOtherRun": "A new analysis result arrived for another capture run.",
    "diagnosis.newResultBatch": "New analysis results arrived for {count} capture runs. Check the run list.",

    "loading.map": "Loading map…",
    "fit.aria": "Show full farm",
    "fit.label": "Fit",
    "orderTip.text": "{at} of {total}",
    "empty.noFlightData": "No flight data",

    "cell.title": "Cell {cellId}",
    "gradeTip.close": "Close summary",
    "gradeTip.detected": (p) =>
      `Detected ${p.count} ${Number(p.count) === 1 ? "photo" : "photos"} · ${p.grade}`,

    "date.openPicker": "Open date picker",
    "date.caret": "Date caret",
    "date.noLogs": "No mission logs",

    "legend.title": "Diagnosis grade",
    "legend.highRange": "{high}% or higher",
    "legend.midRange": "{mid} – {max}%",
    "legend.okNote": "Captured, no issues",
    "legend.none": "Not captured",
    "legend.noneNote": "Not flown this run",

    "tools.diagnosis": "Diag",
    "tools.diagnosisOn": "View diagnosis results for a capture run",
    "tools.diagnosisOff": "Close diagnosis results",
    "tools.zoomIn": "Zoom in",
    "tools.zoomOut": "Zoom out",

    "cellImage.close": "Close image",
    "cellImage.alt": "Crop detail",
    "cellImage.empty": "No image",
    "cellImage.openPreview": "Open image preview",
    "cellImage.thumbAlt": "Crop thumbnail",

    "preview.title": "Cell diagnosis",
    "preview.close": "Close",
    "preview.empty": "No analyzed photos yet.",
    "preview.detected": (p) =>
      `Detected ${p.count} ${Number(p.count) === 1 ? "photo" : "photos"}`,
    "preview.gradcam": "Grad-CAM",
    "preview.tileAria": "Enlarge photo {n}",
    "preview.hint": "Tap a photo to enlarge it",
    "preview.backToList": "List",
    "preview.prev": "Previous photo",
    "preview.next": "Next photo",
    "preview.zoomPos": "{scope}{at} / {total}",

    "ndvi.toggleAlt": "Toggle NDVI",
    "dateModal.title": "Select Date",
    "dateModal.cancel": "Cancel",
    "dateModal.apply": "Apply",
  },
};

export default map;
